const map = {
	"./estanteV1.PNG": 5905,
	"./estanteV2.PNG": 40250,
	"./estanteV3.PNG": 40611,
	"./estanteV4.PNG": 20556,
	"./estanteV5.PNG": 27957,
	"./estanteV6.PNG": 26174,
	"./estanteV7.PNG": 73095,
	"./estanteV8.PNG": 48288
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31006;